let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("641zn")).then(() => parcelRequire('dHx1n'));